document.addEventListener("DOMContentLoaded", function() {
	$(document).ready(function(){
		function checkScroll() {
			if ($(window).scrollTop() > 0) {
				$('body').addClass('scrolled');
			} else {
				$('body').removeClass('scrolled');
			}
		}
	
		$(window).on('scroll', checkScroll);
		checkScroll();

		$("body").on("click",".menu-opener",function(){
			$(this).toggleClass('opened').prev('nav').toggleClass('opened');
			$("header .wp-block-buttons").toggleClass('opened');
		});

		if($(".faq__item").length > 0){
			$(".faq__item .read_more_button, .faq__item--content > .faq_title").click(function(e){
				e.preventDefault();
				$(this).parent('.faq__item--content').find('.answer').slideToggle();
				$(this).parent('.faq__item--content').find('.read_more_button').toggleClass('opened');

				return false;
			});
		}
	});	
});
